<template>
  <v-card
    class="text-center"
    flat
    :style="{ top: `${top}px` }"
    :dark="darkMode"
  >
    <v-card-text class="pa-2">
      <slot>This section is subjected to subscription.</slot>
      <div>Subscribe to a paid plan to enable it.</div>
    </v-card-text>
    <v-card-actions>
      <div class="d-flex mx-auto">
        <v-btn text color="primary" @click="contactUs">
          Contact us
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SubscriptionAlert",
  props: {
    top: { default: 0, type: Number }
  },
  computed: {
    ...mapGetters(["darkMode"])
  },
  methods: {
    contactUs() {
      window.open(process.env.APP_CUSTOMER.contactUs, "_newtab");
    }
  }
};
</script>
